// Angular
import { Component } from '@angular/core';

// Formly
import { FieldType } from '@ngx-formly/core';

@Component({
    selector: 'formly-field-textarea',
    templateUrl: './textarea.type.component.html',
})
export class FormlyFieldTextArea extends FieldType {
    defaultOptions = {
        templateOptions: {
            cols: 1,
            rows: 1,
        },
    };
}
